export enum ServiceConstants {
  NOT_IMPLEMENTED = 'serviceSelection/NOT_IMPLEMENTED',
  SET_SERVICES_LIST = 'serviceSelection/SET_SERVICES_LIST',
  SET_IS_LOADING = 'serviceSelection/SET_IS_LOADING',
}
